import { AuthSteps, PostLoginSteps, buildPostLoginRouteMap, buildStepRouteMap } from '@/lib/auth';
// one lazy entry (authChunk.ts) for every screen below, so webpack builds one "auth" chunk; the comment only names the file
const auth = () => import(/* webpackChunkName: "auth" */ './authChunk');
const AuthLayout = () => auth().then((m) => m.AuthLayout);
const LoginScreen = () => auth().then((m) => m.LoginScreen);
const LinkScreen = () => auth().then((m) => m.LinkScreen);
const MfaSetupScreen = () => auth().then((m) => m.MfaSetupScreen);
const MfaVerifyScreen = () => auth().then((m) => m.MfaVerifyScreen);
const PasswordScreen = () => auth().then((m) => m.PasswordScreen);
const ProfileUpdateScreen = () => auth().then((m) => m.ProfileUpdateScreen);
const LogoutScreen = () => auth().then((m) => m.LogoutScreen);
export const AuthRouteNames = {
    Login: 'AuthLogin',
    Link: 'AuthLink',
    MfaSetup: 'AuthMfaSetup',
    MfaVerify: 'AuthMfaVerify',
    Password: 'AuthPassword',
    ResetPassword: 'AuthResetPassword',
    Logout: 'AuthLogout',
};
/** The router guard (router.js) wants isPublic on every matched record, so each screen carries it, not just the parent */
const publicScreen = (record) => ({ ...record, meta: { isPublic: true, ...record.meta } });
const screens = [
    { path: '', redirect: { name: AuthRouteNames.Login } },
    { path: 'login', name: AuthRouteNames.Login, component: LoginScreen, meta: { title: 'Login', authSteps: [AuthSteps.Login, AuthSteps.Fail] } },
    { path: 'mfa-setup', name: AuthRouteNames.MfaSetup, component: MfaSetupScreen, meta: { title: '2FA Setup', authSteps: [AuthSteps.MfaSetup] } },
    { path: 'mfa-verify', name: AuthRouteNames.MfaVerify, component: MfaVerifyScreen, meta: { title: 'Verify', authSteps: [AuthSteps.MfaVerify] } },
    { path: 'password', name: AuthRouteNames.Password, component: PasswordScreen, meta: { title: 'Change Password', authSteps: [AuthSteps.PasswordChange] } },
    // landings of the emailed links; the reset screen stays put on a rejected password (PASSWORD_CHANGE)
    { path: 'link', name: AuthRouteNames.Link, component: LinkScreen, meta: { title: 'One-Click Login' } },
    { path: 'reset-password', name: AuthRouteNames.ResetPassword, component: PasswordScreen, props: { mode: 'reset' }, meta: { title: 'Reset Password', authSteps: [AuthSteps.PasswordChange] } },
    { path: 'logout', name: AuthRouteNames.Logout, component: LogoutScreen, meta: { title: 'Logout' } },
];
/**
 * The V2 auth screens, in one nested structure under /auth/ (spec §12).
 * authScreen (on the parent, so every child has it) marks the login screens; authSteps names the steps a screen shows,
 * and the step → screen map below comes from this same structure.
 */
export const authRoutes = [
    {
        path: '/auth',
        component: AuthLayout,
        meta: { isPublic: true, authScreen: true },
        children: screens.map(publicScreen),
    },
];
export const stepRoutes = buildStepRouteMap(authRoutes);
export const POST_LOGIN_PATH = '/post-login';
export const PostLoginRouteNames = {
    Profile: 'PostLoginProfile',
};
/**
 * The post-login steps (session.postLoginSteps): logged in, so not public and not auth screens (a 401 acts as in the app).
 * postLoginStep names the step a route shows; the router guard keeps the user on the first open one, and its child routes.
 */
export const postLoginRoutes = [
    {
        path: POST_LOGIN_PATH,
        component: AuthLayout,
        meta: { isPublic: false },
        children: [{ path: 'profile', name: PostLoginRouteNames.Profile, component: ProfileUpdateScreen, meta: { title: 'Update Profile', postLoginStep: PostLoginSteps.ProfileUpdate } }],
    },
];
export const postLoginStepRoutes = buildPostLoginRouteMap(postLoginRoutes);
